import React, { useEffect, useState } from 'react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useDispatch, useSelector } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import {
  IN_ROOM_DINING_MENU_ITEMS,
  IN_ROOM_DINING_MENU_COMBO,
  IN_ROOM_DINING_MENU_CATEGORIES,
  IN_ROOM_DINING_MENU_CREATE_DRAWER,
  IN_ROOM_DINING_MENU_VIEW,
  IN_ROOM_DINING_MENU_CREATE_TYPE,
} from '../../../../../constants/InRoomDiningConst';
import MenuLibrary from './Menu-Library';
import {
  inRoomDiningCategorySelector,
  inRoomDiningCombosSelector,
  inRoomDiningItemsSelector,
  inRoomDiningMenuFormData,
  getMenuFormData,
  fetchAllInRoomDiningMenu,
  setInRoomDiningItems,
  setInRoomDiningCombo,
  setInRoomDiningCategory,
  inRoomDiningMenuIsPublishedSelector,
  setIsPublished,
  inRoomDiningMenuIdSelector,
  setMenuId,
  menuTypeSelector,
} from '../../../servicesSlice';
import { ArrowBack } from '@material-ui/icons';
import MenuAccordion from './Menu-Accordion';
import {
  addInRoomDiningMenu,
  deleteInRoomDiningMenu,
  updateInRoomDiningMenu,
} from '../../../../../utils/ServicesAPIUtils';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import CancelPopUpModel from './Cancel-Model';
import { Popover, Button, MenuItem, Menu } from '@material-ui/core';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { Typography } from '@mui/material';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const InRoomDiningMenuCreate = (props) => {
  const { toggleDrawer, hotelId, menu, onViewToggle, restaurantId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const menuType = useSelector(menuTypeSelector);
  const inRoomDiningItems = useSelector(inRoomDiningItemsSelector);
  const inRoomDiningCombos = useSelector(inRoomDiningCombosSelector);
  const inRoomDiningCategory = useSelector(inRoomDiningCategorySelector);
  const menuFormData = useSelector(inRoomDiningMenuFormData);
  const [activeTab, setActiveTab] = useState(IN_ROOM_DINING_MENU_ITEMS);
  const [search, setSearch] = useState('');
  const [menuList, setMenuList] = useState(inRoomDiningItems.filter((e) => e.status === true));
  const [showFilterList, setShowFilterList] = useState(false);
  const [mainAnchorEl, setMainAnchorEl] = useState(null);
  const [titleAnchorEl, setTitleAnchorEl] = useState(null);
  const [showTitlePopup, setShowTitlePopup] = useState(false);
  const [category, setCategory] = useState([]);
  const [modalPopup, setModalPopup] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
    type: null,
  });

  useEffect(() => {
    dispatch(setIsPublished(false));
  }, []);

  const setCurrCategory = (dataSet) => {
    let currCategor = [];
    let allItemsIsActive = true;
    let allSubCategoryItemsIsActive = true;
    if (dataSet && dataSet.length > 0) {
      currCategor = dataSet.map((categoryData) => {
        let subCategories = [];
        let items = [];
        if (categoryData.subCategories && categoryData.subCategories.length > 0) {
          subCategories = categoryData.subCategories.map((subCategoriesData, index) => {
            let subCategoriesitems = [];
            if (subCategoriesData.items && subCategoriesData.items.length > 0) {
              subCategoriesitems = subCategoriesData.items.map((subCategoriesItemData) => {
                return {
                  name: subCategoriesItemData.name,
                  id: subCategoriesItemData.id,
                  isActive: categoryData?.isActive
                    ? subCategoriesItemData.isActive
                    : categoryData?.isActive,
                };
              });
            }
            const isEveryItemIsInactive = subCategoriesData.items.every(
              (item) => item.isActive === false,
            );
            const isEveryItemIsActive = subCategoriesData.items.some(
              (item) => item.isActive === true,
            );
            if (isEveryItemIsInactive) {
              allSubCategoryItemsIsActive = false;
            } else if (isEveryItemIsActive) {
              allSubCategoryItemsIsActive = true;
            } else {
              allSubCategoryItemsIsActive = subCategoriesData.isActive;
            }
            return {
              name: subCategoriesData.name,
              isActive: categoryData?.isActive
                ? allSubCategoryItemsIsActive
                : categoryData?.isActive,
              items: subCategoriesitems,
              id: `${index + 1}`,
            };
          });
        }
        if (categoryData?.items && categoryData?.items?.length > 0) {
          items = categoryData?.items?.map((itemsData) => {
            return {
              name: itemsData?.name,
              id: itemsData?.id,
              isActive: categoryData?.isActive ? itemsData?.isActive : categoryData?.isActive,
              type: itemsData?.type,
            };
          });
        }

        const isEveryItemIsInactive = categoryData.items.every((item) => item.isActive === false);
        const isEveryCatgoryItemIsInactive = categoryData.subCategories.every((subCategory) =>
          subCategory.items.every((item) => item.isActive === false),
        );
        const isEveryCatgoryItemIsActive = categoryData.subCategories.some((subCategory) =>
          subCategory.items.some((item) => item.isActive === true),
        );
        const isEveryItemIsActive = categoryData.items.some((item) => item.isActive === true);
        if (isEveryItemIsInactive && isEveryCatgoryItemIsInactive) {
          allItemsIsActive = false;
        } else if (isEveryItemIsActive && isEveryCatgoryItemIsActive) {
          allItemsIsActive = true;
        } else {
          allItemsIsActive = categoryData.isActive;
        }
        return {
          name: categoryData.name,
          id: categoryData.id,
          isActive: categoryData?.isActive,
          subCategories,
          items,
        };
      });
    }
    return currCategor;
  };

  const serFormData = (isActive) => {
    const currFormData = {
      name: menu.name,
      code: menu.code,
      description: menu.description,
      isActive,
      hours: menu.hours,
      categories: menu.categories,
      images: menu.images,
      hotelId,
      restaurantId,
    };
    dispatch(getMenuFormData(currFormData));
  };

  const setNameAndCategory = async (isActive) => {
    serFormData(isActive);
    if (menu?.categories && menu?.categories?.length > 0) {
      const categoryList = menu?.categories?.map((category) => {
        const combo = category?.combo?.map((comboItem) => {
          return {
            ...comboItem,
            type: 'Combo',
          };
        });
        const items = category?.items?.map((item) => {
          return {
            ...item,
            type: 'Items',
          };
        });
        const categoryData = {
          ...category,
          items: [...items, ...combo],
        };
        delete categoryData['combo'];
        return categoryData;
      });
      const currentCategory = await setCurrCategory(categoryList);
      setCategory(currentCategory);
    }
  };

  useEffect(() => {
    if (menu?.id) {
      setNameAndCategory(menu.isActive);
    }
  }, [menu]);

  useEffect(() => {
    const clearSelections = (arr = []) => arr?.map((x) => ({ ...x, selected: false }));
    const clearedItems = clearSelections(inRoomDiningItems);
    const clearedCombos = clearSelections(inRoomDiningCombos);
    const clearedCategories = clearSelections(inRoomDiningCategory);

    dispatch(setInRoomDiningItems(clearedItems));
    dispatch(setInRoomDiningCombo(clearedCombos));
    dispatch(setInRoomDiningCategory(clearedCategories));

    setMenuList(() => {
      if (activeTab === IN_ROOM_DINING_MENU_ITEMS)
        return clearedItems?.filter((items) => items?.status === true);
      if (activeTab === IN_ROOM_DINING_MENU_COMBO)
        return clearedCombos?.filter((combos) => combos?.status === true);
      return clearedCategories?.filter((categories) => categories?.status === true);
    });
    setShowFilterList(false);
  }, [menu?.id]);

  const onSearch = async (text) => {
    setSearch(text);
    const activeMenuList = await getList(activeTab);
    if (text === '') return setMenuList(activeMenuList);
    const filterValue = activeMenuList.filter((list) =>
      list.name.toLowerCase().includes(text.toLowerCase()),
    );
    return setMenuList(filterValue);
  };

  const onChangeCheckbox = async (e, list, ndx) => {
    const listData = [...menuList];
    listData[ndx] = {
      ...list,
      isChecked: list.isChecked === undefined ? true : !list.isChecked,
    };
    setMenuList(listData);
  };

  const onClickTabButton = async (type) => {
    setSearch('');
    setActiveTab(type);
    const listData = await getList(type);
    const isRecordWithFilter = listData.filter((e) => e.selected);
    if (isRecordWithFilter.length > 0) setMenuList(isRecordWithFilter);
    else setMenuList(listData);
  };

  const getList = (type) => {
    let listData = [];
    if (type === IN_ROOM_DINING_MENU_ITEMS) {
      const isActiveItemRecords = inRoomDiningItems.filter((e) => e.status === true);
      listData = isActiveItemRecords;
    } else if (type === IN_ROOM_DINING_MENU_COMBO) {
      const isActiveComboRecords = inRoomDiningCombos.filter((e) => e.status === true);
      listData = isActiveComboRecords;
    } else if (type === IN_ROOM_DINING_MENU_CATEGORIES) {
      const isActiveCategoryRecords = inRoomDiningCategory.filter((e) => e.status === true);
      listData = isActiveCategoryRecords;
    }
    return [...listData];
  };

  const handleFilterMenu = (e, status) => {
    setShowFilterList(!showFilterList);
    setMainAnchorEl(status === 'backdropClick' ? null : e.currentTarget);
  };

  const handleSelectSubMenuItem = (item, e) => {
    const selectedMenu = getList(activeTab);
    const selectedSubMenuIndex = selectedMenu.findIndex((o) => o.id === item.id);
    selectedMenu[selectedSubMenuIndex] = {
      ...item,
      selected: e.target.checked,
    };
    if (activeTab === IN_ROOM_DINING_MENU_ITEMS) dispatch(setInRoomDiningItems(selectedMenu));
    else if (activeTab === IN_ROOM_DINING_MENU_COMBO) dispatch(setInRoomDiningCombo(selectedMenu));
    else if (activeTab === IN_ROOM_DINING_MENU_CATEGORIES)
      dispatch(setInRoomDiningCategory(selectedMenu));

    const filteredRows = selectedMenu.filter((listItems) => listItems.selected);
    if (filteredRows.length > 0) setMenuList(filteredRows);
    else setMenuList(selectedMenu);
  };

  const onClickCategoryAccordion = (event, ndx, status, subCategoryNdx, type) => {
    if (event) event.preventDefault();
    const currCategory = [...category];
    if (type === 'category') currCategory[ndx].isExpanded = status === undefined ? true : !status;
    else if (type === 'subCategories')
      currCategory[ndx].subCategories[subCategoryNdx].isExpanded =
        status === undefined ? true : !status;
    setCategory(currCategory);
  };

  const onClickCategoryActive = (
    event,
    currentData,
    categoryndx,
    subCategoriesNdx,
    subCategoriesItemNdx,
    itemNdx,
    type,
  ) => {
    event.preventDefault();
    const currCategory = [...category];
    if (type === 'categories') {
      const newActiveState = currentData.isActive;
      currCategory[categoryndx] = {
        ...currentData,
        isActive: newActiveState,
      };
      currCategory[categoryndx].items.map((item) => (item.isActive = newActiveState));
      let subCategories = currCategory[categoryndx]?.subCategories?.map((subCategory) => {
        subCategory?.items?.map((item) => (item.isActive = newActiveState));
        subCategory = {
          ...subCategory,
          isActive: newActiveState,
        };
        return subCategory;
      });
      currCategory[categoryndx] = {
        ...currentData,
        subCategories,
      };
    } else if (type === 'subCategories') {
      currCategory[categoryndx].subCategories[subCategoriesNdx] = {
        ...currentData,
        isActive: !currentData.isActive,
      };
      currCategory[categoryndx].subCategories[subCategoriesNdx].items.map(
        (item) => (item.isActive = !currentData.isActive),
      );
    } else if (type === 'subCategoriesItem') {
      currCategory[categoryndx].subCategories[subCategoriesNdx].items[subCategoriesItemNdx] = {
        ...currentData,
        isActive: !currentData.isActive,
      };
      const isEveryItemIsInactive = currCategory[categoryndx].subCategories[
        subCategoriesNdx
      ].items.every((item) => item.isActive === false);
      const isEveryItemIsActive = currCategory[categoryndx].subCategories[
        subCategoriesNdx
      ].items.some((item) => item.isActive === true);
      if (isEveryItemIsInactive)
        currCategory[categoryndx].subCategories[subCategoriesNdx].isActive = false;

      if (isEveryItemIsActive) {
        currCategory[categoryndx].subCategories[subCategoriesNdx].isActive = true;
        currCategory[categoryndx].isActive = true;
      }
    } else if (type === 'items') {
      currCategory[categoryndx].items[itemNdx] = {
        ...currentData,
        isActive: currentData?.isActive,
      };
    }
    const isAnyItemActive = currCategory[categoryndx]?.items?.some(
      (item) => item?.isActive === true,
    );
    const isInSubCategoryActive = currCategory[categoryndx]?.subCategories?.some(
      (subCategory) => subCategory?.isActive === true,
    );
    currCategory[categoryndx].isActive = isAnyItemActive || isInSubCategoryActive;
    dispatch(setIsPublished(false));
    setCategory(currCategory);
  };

  const onItemDragOver = (event) => {
    event.preventDefault();
  };

  const onDragStart = (event, draggableData) => {
    let currDrop = [];
    const getCheckedData = menuList.filter((e) => e.isChecked);
    if (getCheckedData.length > 0) currDrop = getCheckedData;
    else currDrop.push(draggableData);
    event.dataTransfer.setData(
      'dataObject',
      JSON.stringify({ type: activeTab, draggableData: currDrop }),
    );
    const menuData = [...menuList].map((listData) => {
      return { ...listData, isChecked: false };
    });
    setMenuList(menuData);
  };

  const checkDuplicateValue = (dragData, dataSet) => {
    const checkDuplicate = dragData.draggableData.find((d) =>
      dataSet.some((val) => val.id === d.id),
    );
    if (checkDuplicate) return true;
    return false;
  };

  const hasDuplicateValue = (dragData, categoryDataSet, type, categoryIndex, subCategoriesNdx) => {
    if (dragData.type === 'Categories' && type === 'Categories') {
      return checkDuplicateValue(dragData, categoryDataSet);
    }
    if ((dragData.type === 'Items' || dragData.type === 'Combo') && type === 'Categories') {
      return checkDuplicateValue(dragData, categoryDataSet[categoryIndex].items);
    }
    if ((dragData.type === 'Items' || dragData.type === 'Combo') && type === 'subCategory') {
      return checkDuplicateValue(
        dragData,
        categoryDataSet[categoryIndex].subCategories[subCategoriesNdx].items,
      );
    }
  };

  const onDrop = (event, type, categoryIndex, subCategoriesNdx, form) => {
    const dataObject = JSON.parse(event.dataTransfer.getData('dataObject'));
    let currCategory = [...category];
    if (currCategory.length === 0 && dataObject.type === 'Categories') {
      const data = dataObject.draggableData.map((draggableData) => {
        return {
          name: draggableData.name,
          id: draggableData.id,
          items: [],
          subCategories: [],
          isActive: true,
        };
      });
      currCategory = [...currCategory, ...data];
    } else if (currCategory.length > 0) {
      if (dataObject.type === 'Categories' && type === 'Categories' && !form) return false;
      const isDuplicate = hasDuplicateValue(
        dataObject,
        currCategory,
        type,
        categoryIndex,
        subCategoriesNdx,
      );
      if (isDuplicate) {
        notificationManager('danger', `Selected ${dataObject.type} is already added`);
        return false;
      }
      if (dataObject.type === 'Categories' && type === 'Categories') {
        const data = dataObject.draggableData.map((draggableData) => {
          return {
            name: draggableData.name,
            id: draggableData.id,
            items: [],
            subCategories: [],
            isActive: true,
          };
        });
        currCategory = [...currCategory, ...data];
      } else if (
        (dataObject.type === 'Items' || dataObject.type === 'Combo') &&
        type === 'Categories'
      ) {
        currCategory[categoryIndex].isActive = true;
        const itemData = dataObject.draggableData.map((draggableData) => {
          return {
            name: draggableData.name,
            id: draggableData.id,
            isActive: true,
            type: dataObject.type,
          };
        });
        currCategory[categoryIndex].items = [...currCategory[categoryIndex].items, ...itemData];
        if (!currCategory[categoryIndex].isExpanded)
          onClickCategoryAccordion(
            null,
            categoryIndex,
            currCategory[categoryIndex].isExpanded,
            null,
            'category',
          );
      } else if (
        (dataObject.type === 'Items' || dataObject.type === 'Combo') &&
        type === 'subCategory'
      ) {
        currCategory[categoryIndex].isActive = true;
        const itemData = dataObject.draggableData.map((draggableData) => {
          return {
            name: draggableData.name,
            id: draggableData.id,
            isActive: true,
            type: dataObject.type,
          };
        });
        currCategory[categoryIndex].subCategories[subCategoriesNdx].items = [
          ...currCategory[categoryIndex].subCategories[subCategoriesNdx].items,
          ...itemData,
        ];
        if (!currCategory[categoryIndex].subCategories[subCategoriesNdx].isExpanded)
          onClickCategoryAccordion(
            null,
            categoryIndex,
            currCategory[categoryIndex].subCategories[subCategoriesNdx].isExpanded,
            subCategoriesNdx,
            'subCategories',
          );
      }
    }
    dispatch(setIsPublished(false));
    setCategory(currCategory);
  };

  const toggleTitlePopup = (e, status) => {
    setShowTitlePopup(!showTitlePopup);
    setTitleAnchorEl(status === 'backdropClick' ? null : e.currentTarget);
  };

  const onClickeditDetails = () => {
    toggleDrawer(IN_ROOM_DINING_MENU_CREATE_DRAWER, true, menu ? menu : null);
    setShowTitlePopup(false);
    setTitleAnchorEl(null);
  };

  const onCategoryHover = (e, categoryIndex, status, type, subCategoriesNdx, itemNdx) => {
    e.preventDefault();
    const currCategory = [...category];
    if (type === 'Categories') currCategory[categoryIndex].isHovered = status;
    else if (type === 'subCategories')
      currCategory[categoryIndex].subCategories[subCategoriesNdx].isHovered = status;
    else if (type === 'items') currCategory[categoryIndex].items[itemNdx].isHovered = status;
    else if (type === 'subCategoriesItem')
      currCategory[categoryIndex].subCategories[subCategoriesNdx].items[itemNdx].isHovered = status;
    setCategory(currCategory);
  };

  const onDeleteCategory = (e, categoryIndex, type, subCategoriesNdx, itemNdx) => {
    e.preventDefault();
    const currCategory = [...category];
    if (type === 'categories') currCategory.splice(categoryIndex, 1);
    else if (type === 'subCategories')
      currCategory[categoryIndex].subCategories.splice(subCategoriesNdx, 1);
    else if (type === 'items') currCategory[categoryIndex].items.splice(itemNdx, 1);
    else if (type === 'subCategoriesItem')
      currCategory[categoryIndex].subCategories[subCategoriesNdx].items.splice(itemNdx, 1);
    dispatch(setIsPublished(false));
    setCategory(currCategory);
  };

  const onAddSubCategory = (e, categoryIndex, expandedStatus) => {
    e.preventDefault();
    const currCategory = [...category];
    if (
      currCategory[categoryIndex].subCategories &&
      currCategory[categoryIndex].subCategories.length > 0
    ) {
      const lastPos = currCategory[categoryIndex].subCategories.length;
      currCategory[categoryIndex].subCategories[lastPos] = {
        name: `Sub-Category ${lastPos + 1}`,
        items: [],
        isActive: true,
        id: `${lastPos + 1}`,
      };
    } else {
      currCategory[categoryIndex].subCategories = [];
      currCategory[categoryIndex].subCategories[0] = {
        name: `Sub-Category 1`,
        items: [],
        isActive: true,
        id: '1',
      };
    }
    dispatch(setIsPublished(false));
    setCategory(currCategory);
    if (!expandedStatus)
      onClickCategoryAccordion(e, categoryIndex, expandedStatus, null, 'category');
  };

  const onClickSubCategoryName = (
    e,
    subCategory,
    subCategoriesNdx,
    categoryIndex,
    type,
    status,
  ) => {
    const currCategory = [...category];
    if ((type === 'clicked' || type === 'blur') && subCategory.name) {
      currCategory[categoryIndex].subCategories[subCategoriesNdx] = {
        ...subCategory,
        isEditable: status,
      };
    } else {
      currCategory[categoryIndex].subCategories[subCategoriesNdx] = {
        ...subCategory,
        name: e.target.value,
      };
    }
    dispatch(setIsPublished(false));
    setCategory(currCategory);
  };

  const onClickOk = () => {
    dispatch(getMenuFormData({}));
    closeModalPopup();
    onViewToggle(IN_ROOM_DINING_MENU_VIEW, false, null);
    dispatch(setMenuId(null));
  };

  const closeModalPopup = () => {
    setModalPopup({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      type: '',
    });
  };

  const onDeleteMenu = async () => {
    try {
      dispatch(stepUpLoaderCount());
      await deleteInRoomDiningMenu(hotelId, restaurantId, menu.id);
      dispatch(fetchAllInRoomDiningMenu(hotelId));
      onClickOk();
      return notificationManager('success', 'Menu deleted successfully');
    } catch (error) {
      return notificationManager(
        'danger',
        error?.graphQLErrors ? error?.graphQLErrors?.[0]?.message : 'Failed to deleted menu',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const isDelete = () => {
    if (modalPopup.type === 'delete') return onDeleteMenu();
    return onClickOk();
  };

  const checkIsValidCategories = () => {
    const test = category.filter((e) => {
      if (e.items.length === 0 && e.subCategories.length === 0) return false;
      else if (e.subCategories.length > 0) {
        let isValid;
        e.subCategories.forEach((subCategory) => {
          if (subCategory.items.length === 0) isValid = false;
          else isValid = true;
        });
        return isValid;
      } else return true;
    });
    return test.length === category.length;
  };

  const checkIsValidPayload = () => {
    if (
      !menuFormData.name ||
      !menuFormData.code ||
      !menuFormData.hours.length ||
      !menuFormData.hotelId
    )
      return false;
    return true;
  };

  const handleSubmit = async () => {
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const categories = await setCurrCategory(category);
      if (categories.length === 0) return notificationManager('danger', 'Please add categories');
      if (!checkIsValidCategories())
        return notificationManager(
          'danger',
          'Items are missing under categories or sub-categories',
        );
      if (!checkIsValidPayload()) {
        notificationManager('danger', 'Please fill required menu details');
        onClickeditDetails();
        return false;
      }
      const modifiedCategories = categories?.map((category) => {
        let itemList = [],
          comboList = [];
        category?.items?.forEach((item) => {
          if (item?.type === 'Combo') {
            delete item['type'];
            comboList.push({
              ...item,
            });
          } else if (item?.type === 'Items') {
            delete item['type'];
            itemList.push({
              ...item,
            });
          }
        });
        return {
          ...category,
          items: itemList,
          combo: comboList,
        };
      });
      const payload = {
        ...menuFormData,
        isActive: true,
        categories: modifiedCategories,
        menuUrl: '',
        menuType,
      };
      if (menu?.id) {
        payload.id = menu.id;
        await updateInRoomDiningMenu(payload, language);
      } else await addInRoomDiningMenu(payload, language);
      dispatch(fetchAllInRoomDiningMenu(hotelId, restaurantId));
      notificationManager('success', `Menu ${menu?.id ? 'updated' : 'saved'} successfully`);
      onViewToggle(IN_ROOM_DINING_MENU_VIEW, false, null);
      return true;
    } catch (error) {
      if (error?.graphQLErrors) {
        if (error?.graphQLErrors?.[0]?.message === 'ird menu code already exists') {
          notificationManager('danger', 'Menu code already exists');
          return onClickeditDetails();
        } else if (error?.graphQLErrors?.[0]?.message === 'ird menu name already exists') {
          notificationManager('danger', 'Menu name already exists');
          return onClickeditDetails();
        }
        return notificationManager('danger', error?.graphQLErrors[0].message);
      }
      return notificationManager('danger', `Failed to ${menu?.id ? 'update' : 'create'} menu`);
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const onClickDelete = () => {
    setModalPopup({
      id: '',
      name: menu.name,
      title: 'Are you sure you want delete',
      description: 'This action cannot be reversed',
      status: true,
      anchorEl: null,
      type: 'delete',
    });
    setShowTitlePopup(false);
    setTitleAnchorEl(null);
  };
  return (
    <div className='container mt-4 mb-3 pb-4'>
      <div className='d-flex align-items-start'>
        <Button
          variant='text'
          color='secondary'
          size='small'
          startIcon={<ArrowBack />}
          onClick={(e) => {
            menu
              ? onViewToggle(false, null)
              : onViewToggle(IN_ROOM_DINING_MENU_CREATE_TYPE, true, null);
          }}
          className='me-2 mt-5'
        >
          Back
        </Button>
        <div className='card ird-detail-view shadow w-100'>
          <div className='col-md-7 irc-menu-create-title justify-content-center ml-3'>
            <div className='row'>
              <div className='col-md-10'>
                <p className='ird-menu-create-title-text'>{menuFormData.name}</p>
              </div>
              <div className='col-md-2'>
                <span onClick={(e) => toggleTitlePopup(e)}>
                  <Button>
                    <MoreHorizIcon />
                  </Button>
                </span>
                {showTitlePopup && (
                  <Popover
                    id='title-menu'
                    open={showTitlePopup}
                    anchorEl={titleAnchorEl}
                    onClose={toggleTitlePopup}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                  >
                    <div className='container p-1'>
                      <div className='ird-title-popup'>
                        <MenuItem onClick={() => onClickeditDetails()}>
                          <EditIcon className='me-2 action-menu-icon' /> Edit details
                        </MenuItem>
                        {menu?.id && (
                          <MenuItem onClick={() => onClickDelete()}>
                            <DeleteForeverIcon className='me-2 action-menu-icon' /> Delete
                          </MenuItem>
                        )}
                      </div>
                    </div>
                  </Popover>
                )}
              </div>
            </div>
          </div>
          <div className='row justify-content-around'>
            <MenuAccordion
              onClickCategoryAccordion={onClickCategoryAccordion}
              onClickCategoryActive={onClickCategoryActive}
              onItemDragOver={onItemDragOver}
              onDrop={onDrop}
              category={category}
              setCategory={setCategory}
              onCategoryHover={onCategoryHover}
              onDeleteCategory={onDeleteCategory}
              onAddSubCategory={onAddSubCategory}
              onClickSubCategoryName={onClickSubCategoryName}
              activeTab={activeTab}
            />
            <MenuLibrary
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              search={search}
              onSearch={onSearch}
              onChangeCheckbox={onChangeCheckbox}
              onClickTabButton={onClickTabButton}
              menuList={menuList}
              handleFilterMenu={handleFilterMenu}
              showFilterList={showFilterList}
              mainAnchorEl={mainAnchorEl}
              handleSelectSubMenuItem={handleSelectSubMenuItem}
              getList={getList}
              onDragStart={onDragStart}
              handleSubmit={handleSubmit}
            />
          </div>
        </div>
      </div>
      {modalPopup.status && modalPopup.type === 'delete' && (
        <DeletePopupModel
          deletePopUp={modalPopup}
          onDelete={isDelete}
          onDeleteCancel={closeModalPopup}
        />
      )}
      {modalPopup.status && modalPopup.type === 'cancel' && (
        <CancelPopUpModel cancelPopUp={modalPopup} onYes={isDelete} onNo={closeModalPopup} />
      )}
    </div>
  );
};

export default InRoomDiningMenuCreate;
